export enum InternalPermission {
  CHANGE_DASHBOARD_LOGO = 'change-dashboard-logo',

  VIEW_COMPANY = 'view-company',
  CREATE_COMPANY = 'create-company',
  UPDATE_COMPANY = 'update-company',
  ENABLE_DISABLE_COMPANY = 'enabledisable-company',
  DOWNLOAD_COMPANY_LIST = 'download-company-list',
  ASSIGN_CREDIT = 'assign-credit',
  VIEW_COMPANY_CREDIT_HISTORY = 'view-company-credit-history',
  DOWNLOAD_COMPANY_CREDIT_HISTORY = 'download-company-credit-history',

  VIEW_JOB_TYPE = 'view-job-type',
  CREATE_JOB_TYPE = 'create-job-type',
  UPDATE_JOB_TYPE = 'update-job-type',
  ENABLE_DISABLE_JOB_TYPE = 'enabledisable-job-type',

  VIEW_HQ_USER = 'view-hq-user',
  CREATE_HQ_USER = 'create-hq-user',
  UPDATE_HQ_USER = 'update-hq-user',
  ENABLE_DISABLE_HQ_USER = 'enabledisable-hq-user',

  // Was accidentally aliased to feature id 18 ("View Applicant") due to a numeric
  // enum collision; there is no dedicated backend feature for this page, so it now
  // deliberately shares the "View Company Credit History" feature instead.
  VIEW_COMPANY_DEBIT_CREDIT_HISTORY = 'view-company-credit-history',

  VIEW_MANAGER = 'view-manager',
  CREATE_MANAGER = 'create-manager',
  UPDATE_MANAGER = 'update-manager',
  ENABLE_DISABLE_MANAGER = 'enabledisable-manager',

  VIEW_APPLICANT = 'view-applicant',
  CREATE_APPLICANT = 'create-applicant',
  UPDATE_APPLICANT = 'update-applicant',
  ENABLE_DISABLE_APPLICANT = 'enabledisable-applicant',
  VERIFY_IDENTITY_DOCUMENT = 'verify-identity-document',
  VIEW_APPLICANT_SLOT_HISTORY = 'view-applicant-slot-history',
  DOWNLOAD_JOB_SUMMARY = 'download-payment-summary',

  VIEW_EDUCATIONAL_INSTITUTE = 'view-educational-institute',
  CREATE_EDUCATIONAL_INSTITUTE = 'create-educational-institute',
  UPDATE_EDUCATIONAL_INSTITUTE = 'update-educational-institute',
  ENABLE_DISABLE_EDUCATIONAL_INSTITUTE = 'enabledisable-educational-institute',

  VIEW_LOCATION = 'view-location',

  VIEW_BILLING_RECORD = 'view-billing-record',

  VIEW_PAYMENT_SUMMARY = 'view-job-summary',
  VIEW_PAYMENT_PROCESSED = 'view-job-payment',
  VIEW_PAYMENT_FUTURE = 'view-future-payment',
  DOWNLOAD_JOB_PAYMENT = 'download-job-payment',
  BANK_PROCESS = 'bank-process',
  PROCESS_PAYMENT = 'process-payment',
  PROCESS_MULTIPLE_PAYMENT = 'process-multiple-payment',
  GENERATE_PAYSLIP_REQUEST = 'generate-payslip-request',

  VIEW_REPORT = 'view-report',
  DOWNLOAD_REPORT = 'download-report',

  VIEW_INTERNAL_USER = 'view-user',
  CREATE_INTERNAL_USER = 'create-user',
  UPDATE_INTERNAL_USER = 'update-user',
  ENABLE_DISABLE_INTERNAL_USER = 'enabledisable-user',

  CREATE_ROLE = 'create-role',
  ENABLE_DISABLE_ROLE = 'enabledisable-role',
  UPDATE_ROLE = 'update-role',
  VIEW_ROLE = 'view-role',
  VIEW_PERMISSION = 'view-permission',

  VIEW_NOTIFICATION_CONFIGURATION = 'view-notification-configuration',
  UPDATE_NOTIFICATION_CONFIGURATION = 'update-notification-configuration',
  VIEW_OTHER_CONFIGURATION = 'view-other-configuration',
  UPDATE_OTHER_CONFIGURATION = 'update-other-configuration',

  VIEW_JOD_BADGE_CONFIGURATION = 'view-jod-badge-configuration',
  UPDATE_JOD_BADGE_CONFIGURATION = 'update-jod-badge-configuration',

  VIEW_HIRING_MANAGERS = 'view-hiring-manager',
  SA_CREATE_MANAGER = 'create-hiring-manager',
  SA_UPDATE_MANAGER = 'update-hiring-manager',
  SA_ENABLE_DISABLE_MANAGER = 'enabledisable-hiring-manager',

  VIEW_PAYMENT_ADJUSTMENT_APPROVAL = 'view-payment-adjustment-approval',
  CREATE_PAYMENT_ADJUSTMENT_APPROVAL = 'create-payment-adjustment-approval',
  CONFIRM_PAYMENT_ADJUSTMENT_APPROVAL = 'confirm-payment-adjustment-approval',

  VIEW_JOB_POSTING = 'view-job',

  VIEW_CERTIFICATES = 'view-certificates',
  CREATE_CERTIFICATE = 'create-certificate',
  UPDATE_CERTIFICATE = 'update-certificate',
  ENABLE_DISABLE_CERTIFICATE = 'enabledisable-certificate',

  CREATE_SUPER_HQ = 'create-super-hq-user',
  UPDATE_SUPER_HQ = 'update-super-hq-user',
  LIST_SUPER_HQ = 'list-super-hq-user',
  ENABLE_DISABLE_SUPERHQ_USER = 'enabledisable-super-hq-user',

  VIEW_SLOT_USER = 'view-job-slot-user',
  EDIT_SLOT_USER = 'edit-job-slot-user',

  // Auto Select Location Setting
  AUTO_SELECT_LOCATION_SETTING = 'update-location-auto-select-internal',

  VIEW_ROSTER = 'view-roster-internal-user',
  DOWNLOAD_ROSTER = 'download-roster-internal-user',

  VIEW_CANCELLATION_PENALTIES = 'list-cancellation-penalties',
  APPROVE_CANCELLATION_PENALTIES = 'approve-cancellation-penalty',
  WAIVE_CANCELLATION_PENALTIES = 'reject-cancellation-penalty',

  LIST_USER_BANS = 'list-user-bans',
  CREATE_USER_BAN = 'create-user-ban',
  LIFT_USER_BAN = 'lift-user-ban',
}

export enum PartnerPermission {
  DOWNLOAD_SERVICE_CONTRACT = 'download-service-contract-hq-level',
  VIEW_JOB_OVERVIEW = 'view-job-overview',
  VIEW_HIRING_OVERVIEW = 'view-hiring-overview',
  VIEW_CREDIT_OVERVIEW = 'view-credit-overview',
  VIEW_RATING_OVERVIEW = 'view-rating-overview',

  VIEW_JOB = 'view-job',
  CREATE_JOB = 'create-job',
  UPDATE_JOB = 'update-job',
  DELETE_JOB = 'delete-job',
  APPROVE_REJECT_PENDING_JOB = 'approvereject-pending-job-hq-level',
  VIEW_APPLIED_APPLICANT = 'view-applied-applicant',
  APPROVE_APPLICANT = 'approve-applicant',
  CANCEL_APPLICANT = 'cancel-applicant',
  CLOCK_IN_CLOCK_OUT_APPLICANT_SLOT = 'clock-inclock-out-applicant-slot',
  VIEW_JOB_HISTORY = 'view-job-history',
  DOWNLOAD_JOB_HISTORY = 'download-job-history',
  BULK_UPDATE_JOB_WAGE = 'bulk-update-job-wage-hq-level',
  CANCEL_MULTIPLE_JOB = 'cancel-multiple-job-hq-level',

  VIEW_CANDIDATE = 'view-candidate',

  VIEW_LOCATION_CREDIT = 'view-location-credit',
  VIEW_CREDIT_HISTORY = 'view-credit-history',
  VIEW_LOCATION = 'view-location-partner',
  VIEW_LOCATION_FEEDBACK = 'view-location-feedback',
  CREATE_LOCATION = 'create-location-hq-level',
  UPDATE_LOCATION = 'update-location-hq-level',
  ENABLE_DISABLE_LOCATION = 'enabledisable-location-hq-level',
  ASSIGN_CREDIT = 'assign-credit-hq-level',

  DOWNLOAD_CREDIT_HISTORY = 'download-credit-history',

  VIEW_MANAGER = 'view-manager-hq-level',
  CREATE_MANAGER = 'create-manager-hq-level',
  UPDATE_MANAGER = 'update-manager-hq-level',
  ENABLE_DISABLE_MANAGER = 'enabledisable-manager-hq-level',

  VIEW_JOB_TEMPLATE = 'view-job-template',
  CREATE_JOB_TEMPLATE = 'create-job-template',
  UPDATE_JOB_TEMPLATE = 'update-job-template',
  ENABLE_DISABLE_JOB_TEMPLATE = 'enabledisable-job-template',

  VIEW_POST_JOBS = 'view-post-jobs',
  VIEW_MAKE_SELECTIONS = 'view-make-selections',
  VIEW_CLOCK_IN_AND_OUT = 'view-clock-in-and-out',

  // Added Permissions
  ENABLE_DISABLE_ROLE = 'enabledisable-role',
  UPDATE_ROLE = 'update-role',
  VIEW_ROLE = 'view-role',
  VIEW_PERMISSION = 'view-permission',

  // UKG Sync Schedule
  UKG_SYNC_SCHEDULE = 'ukg-sync-schedules',

  // Auto Select Location Setting
  AUTO_SELECT_LOCATION_SETTING = 'update-location-auto-select-hq-user',

  VIEW_ROSTER = 'view-roster-partner-user',
  DOWNLOAD_ROSTER = 'download-roster-partner-user',
}

export type SystemPermission = InternalPermission | PartnerPermission;
